import React from 'react';
import { Layout, Typography, Button, Card, Row, Col } from 'antd';
import { 
  PlusOutlined, 
  HistoryOutlined, 
  UserOutlined, 
  MessageOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

const Home = () => {
  const { user, logout } = useAuth();

  return (
    <Layout className="layout" style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#8d6e63' }}>
        <div className="logo" style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
          千方智能问诊系统
        </div>
        <div>
          <Text style={{ color: 'white', marginRight: '15px' }}>
            欢迎，{user?.name || '用户'}
          </Text>
          <Button type="link" onClick={logout} style={{ color: 'white' }}>
            退出登录
          </Button>
        </div>
      </Header>
      
      <Content style={{ padding: '50px 50px' }}>
        <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
          欢迎使用千方智能问诊系统
        </Title>
        
        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={12} md={4} lg={4}>
            <Card 
              hoverable 
              style={{ textAlign: 'center', height: '100%' }}
              bodyStyle={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '30px 20px' }}
            >
              <PlusOutlined style={{ fontSize: '48px', color: '#8d6e63', marginBottom: '20px' }} />
              <Title level={4}>千方问诊</Title>
              <Text type="secondary" style={{ marginBottom: '20px' }}>
                辅助千方专家进行诊断和调理
              </Text>
              <Link to="/consultation">
                <Button type="primary" size="large" style={{ backgroundColor: '#8d6e63', borderColor: '#8d6e63' }}>
                  立即开始
                </Button>
              </Link>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={4} lg={4}>
            <Card 
              hoverable 
              style={{ textAlign: 'center', height: '100%' }}
              bodyStyle={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '30px 20px' }}
            >
              <LineChartOutlined style={{ fontSize: '48px', color: '#52c41a', marginBottom: '20px' }} />
              <Title level={4}>健康趋势</Title>
              <Text type="secondary" style={{ marginBottom: '20px' }}>
                查看您的健康数据和变化趋势
              </Text>
              <Link to="/health-trends">
                <Button type="primary" size="large" style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                  查看趋势
                </Button>
              </Link>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={4} lg={4}>
            <Card 
              hoverable 
              style={{ textAlign: 'center', height: '100%' }}
              bodyStyle={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '30px 20px' }}
            >
              <MessageOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: '20px' }} />
              <Title level={4}>千方问答</Title>
              <Text type="secondary" style={{ marginBottom: '20px' }}>
                智能AI系统回答各类疾病问题
              </Text>
              <Link to="/chat">
                <Button type="primary" size="large" style={{ backgroundColor: '#1890ff', borderColor: '#1890ff' }}>
                  开始对话
                </Button>
              </Link>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={4} lg={4}>
            <Card 
              hoverable 
              style={{ textAlign: 'center', height: '100%' }}
              bodyStyle={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '30px 20px' }}
            >
              <HistoryOutlined style={{ fontSize: '48px', color: '#8d6e63', marginBottom: '20px' }} />
              <Title level={4}>历史记录</Title>
              <Text type="secondary" style={{ marginBottom: '20px' }}>
                查看问诊历史记录
              </Text>
              <Link to="/history">
                <Button type="primary" size="large" style={{ backgroundColor: '#8d6e63', borderColor: '#8d6e63' }}>
                  查看记录
                </Button>
              </Link>
            </Card>
          </Col>
          
          <Col xs={24} sm={12} md={4} lg={4}>
            <Card 
              hoverable 
              style={{ textAlign: 'center', height: '100%' }}
              bodyStyle={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '30px 20px' }}
            >
              <UserOutlined style={{ fontSize: '48px', color: '#8d6e63', marginBottom: '20px' }} />
              <Title level={4}>个人中心</Title>
              <Text type="secondary" style={{ marginBottom: '20px' }}>
                管理个人信息和健康档案
              </Text>
              <Link to="/profile">
                <Button type="primary" size="large" style={{ backgroundColor: '#8d6e63', borderColor: '#8d6e63' }}>
                  进入中心
                </Button>
              </Link>
            </Card>
          </Col>
        </Row>
      </Content>
      
      <Footer style={{ textAlign: 'center' }}>
        千方智能问诊系统 ©{new Date().getFullYear()} 版权所有
      </Footer>
    </Layout>
  );
};

export default Home;